type PichinchaPaymentLinkParams = {
  isPichincha: boolean;
  isPaymentPromise: boolean;
  isRefinance: boolean;
  isCreditCard: boolean;
  gT: (key: string) => string;
};
export function getPichinchaPaymentLink({
  isPichincha,
  isPaymentPromise,
  isRefinance,
  isCreditCard,
  gT,
}: PichinchaPaymentLinkParams): string {
  const isPichinchaPaymentPromise = isPichincha && isPaymentPromise;
  const isPichinchaRefinance = isPichincha && isRefinance;

  if (isPichinchaPaymentPromise || isPichinchaRefinance) {
    if (isCreditCard) {
      return gT('credit_card_payment_link');
    }

    return gT('personal_credit_payment_link');
  }
  return '';
}
